<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div style="margin-top: 28px"></div>
    <div class="card-header pb-0 col-sm-12 d-flex">
      <div class="col-sm-12 col-xs-12">
        <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
          <h1 class="fw-bold page-title">
            구독 상품관리
          </h1>
          <span class="pageDesc">구독 상품을 등록하고 관리할 수 있습니다.</span>
        </div>
      </div>
    </div>
    
    <!-- 상품 목록 테이블 -->
    <div class="card-body px-0 pt-0 pb-2 table-with-search" style="margin-top: 20px">
      <div class="card content-wrap-card col-sm-12 col-xs-12 tableCard p-0">
        <div class="table-buttons">
          <a-button type="default" @click="showSettlementRatesModal">
            센터플로우 협력업체 정산표 보기
          </a-button>
          <a-button type="primary" class="yellow-button add-product-btn" @click="handleAddProductModal">
            상품 추가
          </a-button>
          <a-button type="primary" class="yellow-button add-subscription-btn" @click="navigateToAddSubscription">
            구독 추가
          </a-button>
        </div>
        
        <div class="table-responsive table-wrap">
          <a-table class="ant-table-striped"
                   size="small"
                   bordered
                   :loading="dataLoading"
                   :scroll="tableScroll"
                   :columns="productColumns"
                   :data-source="productList"
                   :pagination="false"
          >
            <template #emptyText>
              <div class="noData">
                <i class="fa-solid fa-exclamation-triangle" style="font-size: 24px; margin-bottom: 10px"/><br>
                <span>등록된 상품이 없습니다.</span>
              </div>
            </template>
            
            <template #bodyCell="{ column, record }">
              <template v-if="column.dataIndex === 'actions'">
                <a-space>
                  <a-button size="small" type="primary" @click="handleEditProduct(record)">수정</a-button>
                  <a-button size="small" danger @click="handleDeleteProduct(record)">삭제</a-button>
                </a-space>
              </template>
            </template>
          </a-table>
        </div>
      </div>
    </div>
    
    <!-- 상품 추가/수정 모달 컴포넌트 사용 -->
    <upsert-product-modal
      :visible="productModal.visible"
      :loading="productModal.loading"
      :is-edit="productModal.isEdit"
      :product-data="productModal.form"
      @cancel="handleModalCancel"
      @save="handleSaveProduct"
    />
    
    <!-- 센터플로우 정산 가격표 모달 -->
    <centerflow-settlement-rates-modal
      :visible="settlementRatesModal.visible"
      @cancel="settlementRatesModal.visible = false"
    />
  </div>
</template>

<script>
import UpsertProductModal from './UpsertProductModal.vue';
import CenterflowSettlementRatesModal from './CenterflowSettlementRatesModal.vue';
import subscriptionSkuApis from './api';
import { twoBtnDialog } from '@/utils/utils';
import { getBillingTypeLabel } from '../enums';

export default {
  name: "SubscriptionProductManagement",
  components: {
    UpsertProductModal,
    CenterflowSettlementRatesModal
  },
  data() {
    return {
      dataLoading: false,
      tableScroll: null,
      
      // 상품 테이블 데이터
      productColumns: [
        { title: '상품 그룹', dataIndex: 'productGroup', key: 'productGroup', align: 'center', fixed: 'left', width: 120 },
        { title: '상품명', dataIndex: 'productName', key: 'productName', align: 'center', fixed: 'left', width: 150 },
        { title: '과금 방식', dataIndex: 'billingType', key: 'billingType', align: 'center', width: 100,
          customRender: ({text}) => getBillingTypeLabel(text) },
        { title: '설치비', dataIndex: 'installationFee', key: 'installationFee', align: 'right', width: 120,
          customRender: ({text}) => `${(text || 0).toLocaleString()}원` },
        { title: '사용료', dataIndex: 'price', key: 'price', align: 'right', width: 120,
          customRender: ({text}) => `${(text || 0).toLocaleString()}원` },
        { title: '설명', dataIndex: 'description', key: 'description', align: 'left', width: 250 },
        { title: '작업', dataIndex: 'actions', key: 'actions', align: 'center', width: 150, fixed: 'right' }
      ],
      productList: [],  // 서버에서 가져온 데이터로 채워짐
      
      // 페이지네이션 데이터
      paginationData: {
        currentPage: 1,
        totalPages: 1,
        totalDocs: 0,
        limit: 10
      },
      
      // 센터플로우 정산 가격표 모달
      settlementRatesModal: {
        visible: false
      },
      
      // 상품 추가/수정 모달
      productModal: {
        visible: false,
        loading: false,
        isEdit: false,
        form: {
          key: '',
          productGroup: '센터플로우',
          productName: '',
          billingType: 'monthly',
          installationFee: 0,
          price: 0,
          description: ''
        }
      }
    };
  },
  mounted() {
    this.initTableScroll();
    window.addEventListener('resize', this.handleResize);
    this.loadSubscriptionProducts();
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.initTableScroll();
    },
    initTableScroll() {
      const width = window.innerWidth;
      if (width < 768) {
        this.tableScroll = { x: '1200px' };
      } else {
        this.tableScroll = { x: '1500px' };
      }
    },
    
    // 센터플로우 정산 가격표 모달 표시
    showSettlementRatesModal() {
      this.settlementRatesModal.visible = true;
    },
    
    // 상품 추가 모달 열기
    handleAddProductModal() {
      this.productModal.isEdit = false;
      this.productModal.form = {
        key: '',
        productGroup: '센터플로우',
        productName: '',
        billingType: 'monthly',
        installationFee: 0,
        price: 0,
        description: ''
      };
      this.productModal.visible = true;
    },
    
    // 상품 수정 모달 열기
    handleEditProduct(record) {
      this.productModal.isEdit = true;
      this.productModal.form = { ...record };
      this.productModal.visible = true;
    },
    
    // 모달 취소 처리
    handleModalCancel() {
      this.productModal.visible = false;
    },
    
    // 상품 삭제 처리
    async handleDeleteProduct(record) {
      const isConfirmed = await twoBtnDialog(
        '삭제 확인',
        `"${record.productName}" 상품을 삭제하시겠습니까?`,
        '삭제'
      );
      
      if (!isConfirmed) return;
      
      this.apiHandler().deleteSubscriptionProduct(
        record.key,
        (response) => {
          this.$message.success('구독 상품이 성공적으로 삭제되었습니다.');
          this.loadSubscriptionProducts(); // 목록 갱신
        },
        (error) => {
          console.error('구독 상품 삭제 실패:', error);
          this.$message.error('구독 상품 삭제에 실패했습니다.');
        }
      );
    },
    
    // 상품 저장 처리
    handleSaveProduct(formData) {
      this.productModal.loading = true;
      
      if (this.productModal.isEdit) {
        // 수정 로직
        const productId = formData.key;
        
        // key 필드는 제외
        const { key, ...updateData } = formData;
        
        this.apiHandler().updateSubscriptionProduct(
          productId,
          updateData,
          (response) => {
            this.$message.success('구독 상품이 성공적으로 수정되었습니다.');
            this.productModal.loading = false;
            this.productModal.visible = false;
            this.loadSubscriptionProducts(); // 목록 갱신
          },
          (error) => {
            console.error('구독 상품 수정 실패:', error);
            this.$message.error('구독 상품 수정에 실패했습니다.');
            this.productModal.loading = false;
          }
        );
      } else {
        // 추가 로직 - key 필드가 있다면 제거되어야 함 (UpsertProductModal에서 이미 처리했지만 한번 더 확인)
        const createData = formData.key ? { ...formData } : formData;
        if (createData.key) {
          delete createData.key;
        }
        
        this.apiHandler().createSubscriptionProduct(
          createData,
          (response) => {
            this.$message.success('구독 상품이 성공적으로 추가되었습니다.');
            this.productModal.loading = false;
            this.productModal.visible = false;
            this.loadSubscriptionProducts(); // 목록 갱신
          },
          (error) => {
            console.error('구독 상품 추가 실패:', error, createData);
            this.$message.error(`구독 상품 추가에 실패했습니다: ${error.response?.data?.message || error.message}`);
            this.productModal.loading = false;
          }
        );
      }
    },
    
    // 구독 상품 데이터 로드
    loadSubscriptionProducts() {
      this.dataLoading = true;
      
      // 검색 조건 설정
      const params = {
        page: this.paginationData.currentPage,
        limit: this.paginationData.limit
      };
      
      // 필터 조건이 있는 경우에만 추가
      if (this.paginationData.productGroup) {
        params.productGroup = this.paginationData.productGroup;
      } else if (this.productGroup) {
        params.productGroup = this.productGroup;
      } else {
        params.productGroup = '센터플로우'; // 기본적으로 센터플로우 그룹의 상품 조회
      }
      
      console.log('구독 상품 목록 요청 파라미터:', params);
      
      this.apiHandler().getSubscriptionProducts(
        params,
        (response) => {
          try {
            const { docs, totalDocs, totalPages } = response.data;
            
            // 확인: docs가 배열인지 체크
            if (!Array.isArray(docs)) {
              console.error('API 응답의 docs가 배열이 아닙니다:', docs);
              this.$message.error('서버 응답 형식이 올바르지 않습니다.');
              this.dataLoading = false;
              return;
            }
            
            this.productList = docs.map(item => ({
              key: item.id || item._id, // MongoDB의 _id 또는 id 필드 사용
              productGroup: item.productGroup || '',
              productName: item.productName || '',
              billingType: item.billingType || 'monthly',
              installationFee: item.installationFee || 0,
              price: item.price || 0,
              description: item.description || ''
            }));
            
            this.paginationData.totalDocs = totalDocs || 0;
            this.paginationData.totalPages = totalPages || 1;
          } catch (error) {
            console.error('구독 상품 데이터 처리 중 오류:', error);
            this.$message.error('구독 상품 데이터 처리 중 오류가 발생했습니다.');
          } finally {
            this.dataLoading = false;
          }
        },
        (error) => {
          console.error('구독 상품 목록 조회 실패:', error);
          
          // 자세한 오류 메시지 표시
          let errorMessage = '구독 상품 목록을 불러오는데 실패했습니다.';
          if (error.response) {
            const statusCode = error.response.status;
            const serverMessage = error.response.data?.message;
            
            if (serverMessage) {
              errorMessage += ` 서버 메시지: ${serverMessage}`;
            } else if (statusCode) {
              errorMessage += ` (${statusCode})`;
            }
          }
          
          this.$message.error(errorMessage);
          this.dataLoading = false;
        }
      );
    },
    
    // API 핸들러
    apiHandler() {
      return subscriptionSkuApis(this.$apiInstance, this.$store);
    },
    
    // 구독 추가 페이지로 이동
    navigateToAddSubscription() {
      this.$router.push('/salesrecords/subscription/create');
    }
  }
};
</script>

<style scoped lang="scss">
.titleContainer {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.page-title {
  color: #000;
  font-size: 1.8rem;
}

.pageDesc {
  color: #6c757d;
  font-size: 14px;
  margin-top: 8px;
}

.table-buttons {
  display: flex;
  justify-content: flex-end;
  margin: 15px;
}

.add-product-btn, .add-subscription-btn {
  margin-left: 8px;
}

.green-button {
  background-color: #52c41a !important;
  border-color: #52c41a !important;
  color: #fff !important;
  
  &:hover {
    background-color: #389e0d !important;
    border-color: #389e0d !important;
  }
  
  &:disabled {
    background-color: #d9d9d9 !important;
    border-color: #d9d9d9 !important;
    color: rgba(0, 0, 0, 0.25) !important;
  }
}

.table-wrap {
  margin: 16px;
}

.noData {
  text-align: center;
  padding: 24px;
  color: #999;
}

:deep(.yellow-button) {
  background-color: #FFCC32 !important;
  border-color: #FFCC32 !important;
  color: #000 !important;
  
  &:hover {
    background-color: #E6B82E !important;
    border-color: #E6B82E !important;
  }
  
  &:disabled {
    background-color: #d9d9d9 !important;
    border-color: #d9d9d9 !important;
    color: rgba(0, 0, 0, 0.25) !important;
  }
}

@media screen and (max-width: 767px) {
  .card-header {
    margin: 0;
  }
}
</style>
